import { Table } from '@statsbomb/kitbag-components';
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  getAlignmentIssueLabel,
  getAlignmentStatusLabel,
} from '../../utils/alignment-data';
import { EMPTY_CELL_VALUE } from '../../constants/tableRows';

const getTranslationString = (intl) => ({
  lastUpdatedBy: intl.formatMessage({
    defaultMessage: 'Last Updated By',
    id: '7ce1b',
  }),
  misalignmentIssue: intl.formatMessage({
    defaultMessage: 'Misalignment Issue',
    id: '275d1',
  }),
  misalignmentStatus: intl.formatMessage({
    defaultMessage: 'Misalignment Status',
    id: 'c3066',
  }),
});

export function MisalignmentStatusTable({
  lastUpdatedBy,
  misalignmentIssue,
  misalignmentStatus,
}) {
  const intl = useIntl();

  return (
    <Table>
      <Table.Head>
        <Table.HeaderCell colSpan={2}>
          {getTranslationString(intl).misalignmentStatus}
        </Table.HeaderCell>
      </Table.Head>
      <Table.Body>
        <Table.Row>
          <Table.DataCell $textAlign="left">
            {getTranslationString(intl).lastUpdatedBy}
          </Table.DataCell>
          <Table.DataCell $textAlign="left">
            {lastUpdatedBy || EMPTY_CELL_VALUE}
          </Table.DataCell>
        </Table.Row>
        <Table.Row>
          <Table.DataCell $textAlign="left">
            {getTranslationString(intl).misalignmentIssue}
          </Table.DataCell>
          <Table.DataCell $textAlign="left">
            {getAlignmentIssueLabel(misalignmentIssue, intl)}
          </Table.DataCell>
        </Table.Row>
        <Table.Row>
          <Table.DataCell $textAlign="left">
            {getTranslationString(intl).misalignmentStatus}
          </Table.DataCell>
          <Table.DataCell $textAlign="left">
            {getAlignmentStatusLabel(misalignmentStatus, intl)}
          </Table.DataCell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}

MisalignmentStatusTable.propTypes = {
  lastUpdatedBy: PropTypes.string.isRequired,
  misalignmentIssue: PropTypes.string,
  misalignmentStatus: PropTypes.string,
};

MisalignmentStatusTable.defaultProps = {
  misalignmentIssue: undefined,
  misalignmentStatus: undefined,
};

export default { MisalignmentStatusTable };
